module.exports = __webpack_public_path__ + "static/img/10.1204249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/10.png
// module id = a1Pa
// module chunks = 1